import React, {forwardRef} from 'react';

import {FloatingMenuItem} from '@pb/kit-component-menu';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './listbox.component.module.styl';

import type {FloatingMenuItemProps} from '@pb/kit-component-menu';


const classNames = withCssModule(styles);


// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ListBoxItemProps extends FloatingMenuItemProps {}


/**
 * ListBoxItem component for ListBox
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/utils-listbox--documentation}
 * */
export const ListBoxItem = forwardRef<HTMLLIElement, ListBoxItemProps>(function ListBoxItem(props, ref) {
    const {
        className,
        ...restProps
    } = props;

    return (
        <FloatingMenuItem
            ref={ref}
            tabIndex={-1} // for virtual focus management
            {...restProps}
            className={classNames('list-box-item', className)}
        />
    );
});

ListBoxItem.displayName = 'ListBoxItem';
